import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import LogoIcon from '../../../icons/cofe.svg';
import { Navigations } from './navigations';
import { navBarItems } from '../../../../components/main/paths';
import { Countries } from './countries';
import { UserMenu } from './user-menu';
import { Search } from './search';

const Logo = styled(LogoIcon)`
  margin-right: 0.5rem;
`;

const StyledLayoutHeader = styled(Layout.Header)`
  display: flex;
  align-items: center;
  background-color: white !important;
  width: 100%;
  position: relative;
`;

export function AppHeader(props) {
  return (
    <StyledLayoutHeader {...props}>
      <Logo />
      <Navigations routes={navBarItems} />
      <Search />
      <Countries />
      <UserMenu />
    </StyledLayoutHeader>
  );
}
